import { useState } from 'react'
import { MiniTabbedWidgetWrapper } from '../../../../rapid-ui'
import type { Layer } from '../../data/v1'
import { BoxTabIcon, MaskTabIcon } from '../../glyphs/tabs'
import { useDesignerActions } from '../../use-designer-actions'
import { BackgroundInspector } from './background'
import { MaskInspector } from './mask'

export type BackdropLayerInspectorProps = {
	layer: Extract<Layer, { type: 'backdrop' }>
}

export function BackdropLayerInspector({ layer }: BackdropLayerInspectorProps) {
	const { updateLayer } = useDesignerActions()
	const [tab, setTab] = useState<'box' | 'mask'>('box')

	return (
		<MiniTabbedWidgetWrapper
			value={tab}
			onChange={setTab}
			tabs={[
				{
					id: 'box',
					icon: <BoxTabIcon />,
					label: 'Background',
					children: (
						<BackgroundInspector
							layerId={layer.id}
							value={layer.background}
							onChange={(updates, options) =>
								updateLayer(layer.id, (prev) => ({
									background: { ...(prev as typeof layer).background, ...updates },
								}), options)}
						/>
					),
				},
				{
					id: 'mask',
					icon: <MaskTabIcon />,
					label: 'Mask',
					children: (
						<MaskInspector
							value={layer.mask}
							onChange={(mask) => updateLayer(layer.id, { mask })}
						/>
					),
				},
			]}
		/>
	)
}
